<template>
  <div class="token-app text-left mb-3">
    <div class="d-flex flex-wrap align-items-center justify-content-between">
      <div class="titulo">
        <i class="fa fa-key mr-2"></i>Acesso do app de impressão pela API
      </div>
      <b-button size="sm" variant="outline-primary" :disabled="gerando || !empresa" @click="gerar">
        <i class="fa fa-plus mr-1"></i> Gerar token
      </b-button>
    </div>
    <div class="ajuda">
      No app de impressão, em <b>Configurações</b>, marque <b>Conectar pela API</b> e informe o endereço e o
      token abaixo. Assim o computador não precisa mais do usuário e da senha do banco.
    </div>

    <div class="campo mt-2">
      <label>Endereço da API</label>
      <div class="d-flex">
        <b-input size="sm" :value="url" readonly />
        <b-button size="sm" variant="outline-secondary" class="ml-1" @click="copiar(url, 'Endereço')">
          <i class="fa fa-copy"></i>
        </b-button>
      </div>
    </div>

    <b-alert v-if="novo" show variant="success" class="mt-2 mb-2 small">
      <b>Token gerado.</b> Copie agora: ele não aparece de novo.
      <div class="d-flex mt-1">
        <b-input size="sm" :value="novo" readonly />
        <b-button size="sm" variant="success" class="ml-1" @click="copiar(novo, 'Token')">
          <i class="fa fa-copy"></i> Copiar
        </b-button>
      </div>
    </b-alert>

    <div v-if="tokens.length" class="mt-2">
      <div v-for="t in tokens" :key="t.id" class="token d-flex align-items-center" :class="{ revogado: t.revogado_em }">
        <div class="flex-grow-1">
          <code>{{ t.prefixo }}…</code>
          <span class="ml-2">{{ t.descricao || "sem descrição" }}</span>
          <b-badge v-if="t.revogado_em" variant="secondary" class="ml-2">revogado</b-badge>
          <div class="detalhe">
            criado {{ data(t.criado_em) }} ·
            {{ t.ultimo_uso ? "último uso " + data(t.ultimo_uso) : "nunca usado" }}
          </div>
        </div>
        <b-button v-if="!t.revogado_em" size="sm" variant="outline-danger" @click="revogar(t)">Revogar</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ImpressorasConfigLib from "@/libs/ImpressorasConfigLib";

export default {
  props: { empresa: Object },
  data() {
    return { tokens: [], novo: "", gerando: false, url: ImpressorasConfigLib.urlApi() };
  },
  watch: {
    empresa: { immediate: true, handler: "carregar" },
  },
  methods: {
    async carregar() {
      this.novo = "";
      if (!this.empresa) return;
      try {
        const res = await ImpressorasConfigLib.tokens(this.empresa.cod_empresa);
        this.tokens = res.success ? res.data : [];
      } catch (e) {
        // Sem a migration impressao_api a lista nao carrega; o resto da tela segue.
        this.tokens = [];
      }
    },
    async gerar() {
      const { value: descricao, isConfirmed } = await this.$swal.fire({
        title: "Gerar token do app de impressão",
        input: "text",
        inputPlaceholder: "Descrição (ex.: computadores do salão)",
        showCancelButton: true,
        confirmButtonText: "Gerar",
        cancelButtonText: "Cancelar",
      });
      if (!isConfirmed) return;
      this.gerando = true;
      try {
        const res = await ImpressorasConfigLib.gerarToken(this.empresa.cod_empresa, descricao);
        if (res.success) {
          await this.carregar();
          this.novo = res.data.token;
        } else this.showToast("error", res.message || "Erro ao gerar token");
      } catch (e) {
        const msg = e.response && e.response.data && e.response.data.message;
        this.showToast("error", msg || "Erro ao gerar token");
      }
      this.gerando = false;
    },
    async revogar(t) {
      const { isConfirmed } = await this.$swal.fire({
        title: "Revogar token?",
        text: "Os computadores que usam este token param de imprimir até receberem um token novo.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Revogar",
        cancelButtonText: "Cancelar",
      });
      if (!isConfirmed) return;
      try {
        const res = await ImpressorasConfigLib.revogarToken(this.empresa.cod_empresa, t.id);
        if (res.success) await this.carregar();
        else this.showToast("error", res.message || "Erro ao revogar");
      } catch (e) {
        this.showToast("error", "Erro ao revogar");
      }
    },
    data(valor) {
      return this.$moment(valor).format("DD/MM/YYYY HH:mm");
    },
    copiar(texto, nome) {
      const area = document.createElement("textarea");
      area.value = texto;
      area.style.position = "fixed";
      area.style.opacity = "0";
      document.body.appendChild(area);
      area.select();
      document.execCommand("copy");
      document.body.removeChild(area);
      this.showToast("success", nome + " copiado");
    },
  },
};
</script>

<style lang="scss" scoped>
.token-app {
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  padding: 10px;
  .titulo {
    font-weight: bold;
  }
  .ajuda,
  .detalhe {
    font-size: 12px;
    color: #666;
  }
  label {
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 2px;
  }
  .token {
    background: #f8f8f8;
    border-radius: 4px;
    padding: 6px 8px;
    margin-bottom: 4px;
    &.revogado {
      opacity: 0.6;
    }
  }
}
</style>
